import { useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

const GALLERY_IMAGES = [
  { img: "/images/cafe/c (1).webp", label: "Cafe İç Mekan Uygulaması" },
  { img: "/images/cafe/c (2).webp", label: "Konsept Dekorasyon Detayı" },
  { img: "/images/cafe/c (3).webp", label: "Kurumsal Mekan Tasarımı" },
  { img: "/images/cafe/c (4).webp", label: "Duvar ve Aydınlatma Kurgusu" },
  { img: "/images/cafe/c (5).webp", label: "Marka Kimliğine Uygun Dekor" },
  { img: "/images/cafe/c (6).webp", label: "Servis Alanı Tasarımı" },
  { img: "/images/d/d-1.webp", label: "Dış Cephe Dekorasyon" },
  { img: "/images/d/d-5.webp", label: "Cephe Konsept Uygulama" },
  { img: "/images/d/d-6.webp", label: "Modern Yüzey ve Kaplama" },
  { img: "/images/d/d-10.webp", label: "Kurumsal Cephe Kimliği" },
  { img: "/images/a/a.webp", label: "Anahtar Teslim Dekorasyon Projesi" },
  { img: "/images/marketing-strategy-planning-strategy-concept.jpg", label: "Tasarım Planlama ve Uygulama" },
];

const DekorasyonPage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-32 pb-20 bg-[#0D0D0D] overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="/images/cafe/c (3).webp"
            alt="Dekorasyon"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 mb-6 anim-down d0">
            <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">Dekorasyon</span>
          </div>
          <div className="flex items-center gap-3 mb-5 anim-left d1">
            <div className="w-8 h-[2px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Hizmetlerimiz</span>
          </div>
          <h1 className="font-head font-black uppercase text-white text-[clamp(48px,8vw,96px)] leading-[0.9] anim-up d2">
            Dekorasyon
            <br />
            <span className="text-[#E6A800]">Galeri Sayfası</span>
          </h1>
          <p className="text-white/60 text-sm leading-relaxed max-w-2xl mt-6 anim-up d3">
            Cafe, restoran, mağaza ve dış cephe uygulamalarımızdan seçili çalışmalar.
            Dekorasyon projelerimizde tasarım, üretim ve montajı tek ekipte yönetiyoruz.
          </p>
        </div>
      </section>

      <section className="py-20 bg-[#F7F7F7] border-y border-[#ECECEC]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {GALLERY_IMAGES.map((item, i) => (
              <div
                key={`${item.img}-${i}`}
                className="group overflow-hidden border border-[#E8E8E8] bg-white hover:border-[#E6A800] tr anim-up"
                style={{ transitionDelay: `${i * 45}ms` }}
              >
                <div className="relative h-[260px] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.label}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D]/70 via-[#0D0D0D]/10 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-white font-head font-700 uppercase text-xs tracking-wider">
                      {item.label}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#181614]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center anim-scale">
          <div className="w-10 h-[3px] bg-[#E6A800] mx-auto mb-5" />
          <h2 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9] mb-5">
            Mekanınız İçin
            <br />
            <span className="text-[#E6A800]">Dekorasyon Teklifi Alın</span>
          </h2>
          <p className="text-white/60 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
            Konseptinize uygun dekorasyon çözümlerini birlikte planlayalım. Ücretsiz keşif ve
            hızlı teklif desteği için hemen iletişime geçin.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase text-xs tracking-wider"
            >
              İletişime Geç
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="https://wa.me/905511830918"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/25 text-white hover:bg-white/10 tr font-head font-700 uppercase text-xs tracking-wider"
            >
              <i className="ri-whatsapp-line" />
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DekorasyonPage;
